module.exports = __webpack_public_path__ + "assets/img/h3-logo-outline.b08495db.png";